import {
  DocumentFolderScope,
  DocumentFolderWithFileCountResponse,
} from 'mapistry-shared';

export const DOCUMENT_FOLDER_SCOPE_LABELS: Record<DocumentFolderScope, string> =
  {
    [DocumentFolderScope.ORGANIZATION]: 'Organization Managed',
    [DocumentFolderScope.PROJECT]: 'Site Managed',
  };

export function isOrganizationScopedFolder(
  scope: DocumentFolderScope,
): boolean {
  return scope === DocumentFolderScope.ORGANIZATION;
}

export function getDocumentFolderMoveDestinations(
  documentFolders: DocumentFolderWithFileCountResponse[],
  sourceFolder: Pick<DocumentFolderWithFileCountResponse, 'id' | 'scope'>,
): DocumentFolderWithFileCountResponse[] {
  return documentFolders.filter(
    (folder) =>
      folder.id !== sourceFolder.id && folder.scope === sourceFolder.scope,
  );
}
